import axios from 'axios'

const state = {
  camundaUsers: [],
  camundaSupportUsers: [],
  camundaGroups: []
}

const mutations = {
  setCamundaUsers(state, camundaUsers) {
    state.camundaUsers = camundaUsers
  },
  setCamundaSupportUser(state, camundaUsers) {
    state.camundaSupportUsers = camundaUsers
  },
  setCamundaGroups(state, camundaGroups) {
    state.camundaGroups = camundaGroups
  }
}

let actions = {
  async fetchCamundaUsers({ commit }) {
    let response = await axios.get('/api/core/camundaUsers')
    let camundaUsers = [...response.data]
    commit('setCamundaUsers', camundaUsers)
    return camundaUsers
  },
  async fetchSupportUsers({ commit }) {
    let response = await axios.get(
      '/api/core/camundaUsers?memberOfGroup=support'
    )
    let camundaUsers = [...response.data]
    commit('setCamundaSupportUser', camundaUsers)
    return camundaUsers
  },
  async fetchCamundaGroups({ commit }) {
    let response = await axios.get('/api/core/camundaGroups')
    let camundaGroups = [...response.data]
    commit('setCamundaGroups', camundaGroups)
    return camundaGroups
  }
}

export default {
  state,
  mutations,
  actions
}
